import { Attachment, ConfigurationPlacement, Id, ModulePlacement, WoodType } from '@ess/jg-rule-executor';
import { GetConfigurationByCode_configuration_configurationPlacement } from '@src/app/generated/GetConfigurationByCode';
import { Matrix4 } from 'three';

export class PortalConfigurationPlacement extends ConfigurationPlacement {
  constructor(
    placements?: ModulePlacement[],
    originPlacement?: Id<ModulePlacement>,
    woodType?: WoodType
  ) {
    super(placements, originPlacement, woodType);
  }

  static fromGql(gql: GetConfigurationByCode_configuration_configurationPlacement): PortalConfigurationPlacement {
    return new PortalConfigurationPlacement(
      gql.placements.map(placement => new ModulePlacement(
        placement.id,
        placement.variantId,
        /* eslint-disable @stylistic/max-len */
        new Matrix4().set(
          placement.transformation.r1.c1, placement.transformation.r1.c2, placement.transformation.r1.c3, placement.transformation.r1.c4,
          placement.transformation.r2.c1, placement.transformation.r2.c2, placement.transformation.r2.c3, placement.transformation.r2.c4,
          placement.transformation.r3.c1, placement.transformation.r3.c2, placement.transformation.r3.c3, placement.transformation.r3.c4,
          placement.transformation.r4.c1, placement.transformation.r4.c2, placement.transformation.r4.c3, placement.transformation.r4.c4
        ),
        /* eslint-enable @stylistic/max-len */
        new Map(placement.xAttachments.values.map(
          x => [x.key, new Attachment(x.value.placementId, x.value.yAttachmentId)]
        ))
      )),
      gql.originPlacement,
      gql.woodType
    );
  }
}
